import { LiveSessionView } from '../features/liveSession/liveSessionView.tsx'

export function LiveSessionPage() {
  return <LiveSessionView />
}

